// Partner: SVH
import svhLogo from "../assets/image/logo.png";
import svhLoading from "../assets/image/load_04.gif";

// Partner: SAT
import satLogo from "../assets/image/logo_SAT.png";
import satLoading from "../assets/image/load_SAT.gif";

// Partner: Interpreter
import flagJP from "../assets/image/flag_jp.svg";
import flagCN from "../assets/image/flag_cn.svg";
import flagKR from "../assets/image/flag_kr.svg";
import flagFR from "../assets/image/flag_fr.svg";
import flagAE from "../assets/image/flag_ae.svg";
import flagMN from "../assets/image/flag_mn.svg";

// Partner: TytoCare
import tytoCareLogo from "../assets/image/logo_tytocare.svg";

// Common
import stepsTh from "../assets/image/steps_th.svg";
import stepsEn from "../assets/image/steps_en.svg";
import supportStaff from "../assets/image/support_staff.svg";
import nurse from "../assets/image/icon_nurse.png";
import doctor from "../assets/image/icon_doctor.png";
import idCard from "../assets/image/1_0.png";
import passport from "../assets/image/1_0EN.png";
import point from "../assets/image/point_rate.png";
import noPoint from "../assets/image/nopoint_rate.png";
import connectFail from "../assets/image/connect_fail_icon.png";
import chromeLogo from "../assets/image/chrome_logo.svg";
import wellSuperAppHome from "../assets/image/home.svg";

const assetService = {
  getLogo: (partnerName: string) => {
    switch (partnerName?.toLowerCase()) {
      case "sat":
        return satLogo;
      default:
        return svhLogo;
    }
  },
  getSteps: (language: string) => {
    switch (language?.toLowerCase()) {
      case "th":
        return stepsTh;
      default:
        return stepsEn;
    }
  },

  getSupportStaff: () => supportStaff,

  getChromeLogo: () => chromeLogo,

  getPreparePassport: (language: string) => {
    switch (language?.toLowerCase()) {
      case "th":
        return idCard;
      default:
        return passport;
    }
  },

  getNurse: () => nurse,

  getDoctor: () => doctor,

  getLoading: (partnerName: string) => {
    switch (partnerName?.toLowerCase()) {
      case "sat":
        return satLoading;
      default:
        return svhLoading;
    }
  },

  getPoint: () => point,

  getNoPoint: () => noPoint,

  getFlag: (language: string) => {
    switch (language?.toLowerCase()) {
      case "jp":
        return flagJP;
      case "cn":
        return flagCN;
      case "kr":
        return flagKR;
      case "fr":
        return flagFR;
      case "ae":
        return flagAE;
      case "mn":
        return flagMN;
      default:
        return flagJP;
    }
  },

  getTytoCareLogo: () => tytoCareLogo,

  getConnectFail: () => connectFail,

  getWellSuperAppHome: () => wellSuperAppHome,
};

export { assetService };
